<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12EAMoX/tc-custom/9781626813366.jpg?1701061060939" alt="This image is the cover for the book Rapture's Slave"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rapture's Slave
      </h1>
      <p class="bookDescription body article font2">
        <b>An emperor’s concubine and a courageous gladiator succumb to forbidden passion in a historical romance from the author of <i>Captive of Desire</i>.</b><br/>  <br/> When the virile young Nero first spots the exquisite Acte, illegitimate daughter of Emperor Claudius and a royal household slave, he knows he must have her. But even as Acte finds her deepest desires awakened by the magnificent Nero, she fears his sadistic nature.<br/>  <br/> Though she has been fated to serve as Nero’s carnal playmate when he becomes emperor of Rome, Acte finds the true love she dreams of in Sergio, a handsome gladiator. But in a loveless world where lust and power rule side by side, her secret obsession with Sergio might cost Acte her heart—and both of their lives.<br/>  <br/> “One of the finest and most gifted writers. A master storyteller!” —<i>Romantic Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Becky Lee Weyrich
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0b4d1d28